/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PublicStudentProfile } from '../../models/public-student-profile';

export interface GetStudentProfileCv$Params {
  studentId: string;
}

export function getStudentProfileCv(http: HttpClient, rootUrl: string, params: GetStudentProfileCv$Params, context?: HttpContext): Observable<StrictHttpResponse<PublicStudentProfile>> {
  const rb = new RequestBuilder(rootUrl, getStudentProfileCv.PATH, 'get');
  if (params) {
    rb.path('studentId', params.studentId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PublicStudentProfile>;
    })
  );
}

getStudentProfileCv.PATH = '/studentprofile/{studentId}/publiccv';
